import { temFuncao } from '@/equipe/funcoes';

/**
 * ★★★ A-7a — A TABELA DE METAS POR PESSOA, extraída para casa própria.
 *
 * ⚠⚠ Ela vivia dentro de `DialogoMetas` (o diálogo de `/metas`, que a A-7a tirou do caminho).
 * ★★★ Com o botão "Metas individuais" nascendo em Indicadores, haveria **duas** tabelas
 * iguais na casa — exatamente o erro que produziu três definições de comparecimento. ★ Então
 * ela saiu de lá e os dois diálogos a MONTAM: uma implementação, dois lugares.
 *
 * ★ Só desenha, e guarda o TEXTO digitado: quem normaliza é `salvarMetasPorSdr`.
 */
export default function TabelaMetasPorPessoa({ sdrs = [], metasPorSdr = {}, aoMudar, rotulo = null }) {
  if (sdrs.length === 0) return null;
  return (
    <div className="campo">
      {rotulo && <span className="rotulo-acoes">{rotulo}</span>}
      <div className="tabela-envolve">
        <table className="tabela tabela-metas-pessoa">
          <thead>
            <tr>
              <th>Pessoa</th>
              {/* ★★ WO lote 3a — A UNIDADE ESTÁ NO CABEÇALHO, e não é enfeite.
                  As duas primeiras são do MÊS; as quatro últimas, por DIA. Sem o
                  rótulo dizendo qual é qual, o gestor digita 150 onde cabia 7. */}
              <th>Valor <small>(R$/mês)</small></th>
              <th>Leads trabalhados <small>(mês)</small></th>
              <th className="col-dia">Ligações <small>(por DIA)</small></th>
              {/* ★★★ A-2c (10/out/2026): agendamentos e comparecimentos passaram de MÊS
                  para DIA, por decisão do dono. ⚠⚠ O campo MUDOU DE NOME no banco
                  (`agendamentosDia`), e é isso que impede o "300 por mês" de ser lido
                  como 300 por dia — ★ a coluna nasce VAZIA e o dono redigita. */}
              <th className="col-dia">Agendamentos <small>(por DIA)</small></th>
              <th className="col-dia">Comparecimentos <small>(por DIA)</small></th>
              <th className="col-dia">Follow-ups <small>(por DIA)</small></th>
            </tr>
          </thead>
          <tbody>
            {sdrs.map((s) => {
              const m = metasPorSdr?.[s.id] ?? {};
              const campo = (chave, placeholder, extra = {}) => (
                <td className={extra.className}>
                  <input
                    inputMode="decimal"
                    placeholder={placeholder}
                    value={m[chave] ?? ''}
                    onChange={(e) => aoMudar(s.id, chave, e.target.value)}
                    aria-label={extra.rotulo ?? `${s.nome} — meta de ${chave}`}
                  />
                </td>
              );
              /**
               * ★★ A meta de LIGAÇÕES é de quem exerce a função de SDR; a de
               * FOLLOW-UPS, de quem exerce a de negociador — a separação da WJ.
               * ⚠ O campo some para quem não exerce a função, em vez de aceitar um
               * número que nunca teria realizado para cobrar.
               */
              const ehSdr = temFuncao(s, 'sdr');
              const ehNeg = temFuncao(s, 'negociador');
              return (
                <tr key={s.id}>
                  <td>{s.nome}</td>
                  {campo('valor', 'dividir igualmente')}
                  {campo('leadsTrabalhados', 'sem meta')}
                  {ehSdr
                    ? campo('ligacoesDia', 'ex.: 7', { className: 'col-dia', rotulo: `${s.nome} — meta de ligações por dia` })
                    : <td className="col-dia na" title="só para quem exerce a função de SDR">—</td>}
                  {/* ★ Agendamentos e comparecimentos creditam ao SDR que recebeu o lead,
                      então a coluna segue a função de SDR — a mesma régua das ligações. */}
                  {ehSdr
                    ? campo('agendamentosDia', 'ex.: 3', { className: 'col-dia', rotulo: `${s.nome} — meta de agendamentos por dia` })
                    : <td className="col-dia na" title="só para quem exerce a função de SDR">—</td>}
                  {ehSdr
                    ? campo('comparecimentosDia', 'ex.: 2', { className: 'col-dia', rotulo: `${s.nome} — meta de comparecimentos por dia` })
                    : <td className="col-dia na" title="só para quem exerce a função de SDR">—</td>}
                  {ehNeg
                    ? campo('followUpsDia', 'ex.: 10', { className: 'col-dia', rotulo: `${s.nome} — meta de follow-ups por dia` })
                    : <td className="col-dia na" title="só para quem exerce a função de negociador">—</td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <span className="indicador-nota">
        Valor vazio = a meta da clínica dividida igualmente. As outras, vazias, ficam
        sem meta. Leads, agendamentos e comparecimentos creditam ao SDR que recebeu o lead;
        fechamentos e valor, ao negociador.{' '}
        {/* ⚠⚠ A-2c: o aviso da transição fica na tela, porque o campo antigo existe no
            banco e não é lido mais. ★ Sem isto, o gestor vê "sem meta" onde ele digitou
            300 e pensa que a tela perdeu o dado. */}
        <strong>
          Agendamentos e comparecimentos agora são <u>por dia</u>, como as ligações.
        </strong>{' '}
        As metas por mês digitadas antes não são convertidas (300 por mês não vira 300 por
        dia): o campo aparece vazio e precisa ser digitado de novo, já no valor diário.{' '}
        {/* ★★ A regra do sábado dita na tela: quem digita 7 precisa saber que o
            sábado vale 3, senão o total do mês parece errado. */}
        <strong>Ligações e follow-ups são por DIA</strong> — no sábado valem metade,
        arredondado para baixo (7 por dia vira 3 no sábado). O expediente é
        configurado em Configurações → Desempenho.
      </span>
    </div>
  );
}
